import { render, staticRenderFns } from "./ComplaintTypeChangeActivationType.vue?vue&type=template&id=780f3156&"
import script from "./ComplaintTypeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports